import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from "@angular/core";
import { SideDrawerComponent } from "../shell/side-drawer.component";
import { CrewCommandsStore } from "../core/sim/crew-commands.store";

interface FenderSlot {
  readonly side: "port" | "starboard";
  readonly column: "stern" | "mid" | "bow";
  readonly key: string;
  readonly label: string;
}

const FENDER_SLOTS: readonly FenderSlot[] = [
  { side: "port", column: "stern", key: "stern_port", label: "Rufa" },
  { side: "port", column: "mid", key: "midship_port", label: "Środek" },
  { side: "port", column: "bow", key: "bow_port", label: "Dziób" },
  {
    side: "starboard",
    column: "stern",
    key: "stern_starboard",
    label: "Rufa",
  },
  {
    side: "starboard",
    column: "mid",
    key: "midship_starboard",
    label: "Środek",
  },
  { side: "starboard", column: "bow", key: "bow_starboard", label: "Dziób" },
];

/**
 * Fenders drawer — single-step UX. Each fender position in the 2×3
 * grid acts as a self-explanatory toggle: tap a stowed fender to
 * deploy it, tap a deployed fender to stow it. Visual state (colour,
 * arrow, label) makes the "what happens on next tap" obvious without
 * a separate command panel.
 *
 * Bulk Wystaw / Schowaj buttons sit at the top so the captain can
 * prep all fenders at once when approaching dock.
 */
@Component({
  selector: "po-fenders-drawer",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SideDrawerComponent],
  templateUrl: "./fenders-drawer.component.html",
  styleUrl: "./fenders-drawer.component.css",
})
export class FendersDrawerComponent {
  readonly open = input.required<boolean>();
  readonly anchorBottom = input<number>(64);
  readonly closeRequest = output<void>();

  readonly store = inject(CrewCommandsStore);
  readonly slots = FENDER_SLOTS;
  readonly view = computed(() => this.store.fenders());
}
